import TodoList from "./TodoList";
import { Popover, PopoverTrigger, PopoverContent } from "@chakra-ui/react";

function TodoContainer() {
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <Popover>
        <PopoverTrigger>
          <button className="button4">SPOTIFY</button>
        </PopoverTrigger>
        <PopoverContent>
          <iframe
            src="https://open.spotify.com/embed/playlist/3LFIBdP7eZXJKqf3guepZ1?theme=0"
            width="100%"
            height="380"
            frameBorder="0"
            allowtransparency="true"
            allow="encrypted-media"
            title="spotify"
          ></iframe>
        </PopoverContent>
      </Popover>
      <Popover>
        <PopoverTrigger>
          <button className="button4">TODO</button>
        </PopoverTrigger>
        <PopoverContent>
          <TodoList />
        </PopoverContent>
      </Popover>
    </div>
  );
}

export default TodoContainer;
